module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("ClaimTerms", "Terms and conditions") ))==null?'':__t)+
'</legend><div class="scroll-frame">'+
((__t=( terms ))==null?'':__t)+
'</div> ';
 if ( !isAccepted ) { 
__p+=' <div class="checkbox-wrap no-label"><input type="checkbox" id="terms-accept-input" data-input="terms-accept"> <label class="align-left" for="terms-accept-input">'+
((__t=( i18n.tc("ClaimTerms", "I have read and accepted the terms and conditions.") ))==null?'':__t)+
'</label></div> ';
 } 
__p+=' </fieldset><fieldset class="button-wrap"> ';
 if(!isAccepted ) { 
__p+=' <button data-click="terms-out">'+
((__t=( i18n.tc("ClaimTerms", "Cancel") ))==null?'':__t)+
'</button> <button class="primary" data-click="terms-submit" disabled="disabled">'+
((__t=( i18n.tc("ClaimTerms", "Submit") ))==null?'':__t)+
'</button> ';
} else { 
__p+=' <button class="primary" data-click="terms-exit"> '+
((__t=( i18n.tc("ClaimTerms", "Close") ))==null?'':__t)+
'</button> ';
 } 
__p+=' </fieldset>';
}
return __p;
};
